<template>
  <el-card shadow="never" class="info-card">
    <el-row>
      <el-col :span="2" class="item-text">当前工站：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.current_station_name }}</el-col>
      <el-col :span="2" class="item-text">当前工站状态：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.current_station_status_name }}</el-col>
      <el-col :span="2" class="item-text">当前工站责任人：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.current_station_user_name }}</el-col>
      <el-col :span="2" class="item-text">来货日期：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.receive_time }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="2" class="item-text">检验来源：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.test_source_name }}</el-col>
      <el-col :span="2" class="item-text">供应商：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.supplier_name }}</el-col>
      <el-col :span="2" class="item-text">备件类型：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.plan_category_name }}</el-col>
      <el-col :span="2" class="item-text">SN：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.sn }}</el-col>
    </el-row>

  </el-card>
</template>

<script>
export default {
  name: "StationInfo",
  props: {
    busItem: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
}
</script>

<style scoped>
.el-row {
  line-height: 32px;
}

.info-card {
  margin-top: 10px;
}

.info-card .el-row {
  display: flex;
}

.item-text {
  text-align: right;
}

.item-value {
  color: goldenrod;
}

.item-value.red-tip {
  color: red;
}

.table-header {
  background-color: #ECECECFF;
}
</style>